import useCountryAxiosInstance from "./useCountryAxiosInstance";

const useGetServiceConfiguration = (allBlocks, params={}) => {
  const apiRequest = useCountryAxiosInstance();
  return (serviceId, version) =>
    apiRequest.get(
      `/services_configurations/service/${serviceId}/version/${version}`,
      {
        params: {
          exclude_inactives: !allBlocks,
          ...params,
        }
      }
    );
};

export default useGetServiceConfiguration;
